<template>
<div class="header_main">
  <div class="window__header">
    <!-- Title -->
    <div class="window-title">
      <div class="imgMenu">
        <img src="https://www.xzyds.com/system_avatar.png">
      </div>
      <div class="textMenu">
        <div class="text1">戏中游代售</div>
        <div class="imgMenu2">
          <img src="@/assets/images/shandian.png">
        </div>
        <div class="text2">签署合同 找回包赔</div>
      </div>
    </div>

    <!-- Widget -->
    <div class="window-widget">
      <!-- User -->
      <div class="widget-item m-r-20">
        <div class="notice">
           <div class="text">平台唯一官网：www.xzyds.com</div>
          <img src="@/assets/images/noticeon.png" title="开启声音" class="image" v-if="open" @click="handleclick" />
          <img src="@/assets/images/noticeoff.png" title="关闭声音" class="image" v-else @click="handleclick"/>
        </div>
        <div class="user_info">
          <div class="header_photo">
            <el-image style="border-radius: 2px;" :src="userInfo.avatar"  v-if="userInfo.avatar"/>
          </div>
          <div class="info">
            <div class="nickname">{{userInfo.nickname}}</div>
            <div class="dept">
              {{$net.Connected}}
              <el-popover trigger="click">
                <div>
                  <div class="online-select off" slot="reference" v-if="Connected===true" @click="Disconnect" ><div class="online-circle"></div>切换离线 </div>
                  <div class="online-select"  @click="Reconnect" v-else ><div class="online-circle"></div>切换在线</div>
                </div>
                <span class="online off" slot="reference" v-if="Connected===false">离线</span>
                <span class="online" slot="reference" v-else >在线</span>
              </el-popover>
              <span class="dept_name">{{userInfo.dept_name}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Logout -->
      <el-popconfirm title="确定退出吗？" @confirm="handleLogout">
        <div class="widget-item" slot="reference">
          <span class="m-l-6">退出</span>
        </div>
      </el-popconfirm>
    </div>
  </div>
  <div class="kefu_eff" :class="eff.reply_count>0&&eff.valid_reply/eff.reply_count<0.6?'eff_invalid':''">
    <div><i class="iconfont">今日接待统计:</i></div>
    <div><i class="iconfont icon-chat">接待人数:{{eff.chat}}人</i></div>
    <div><i class="iconfont icon-reply">回复数量:{{eff.reply_count}}次</i></div>
    <div  :class="eff.reply_count>0&&eff.valid_reply/eff.reply_count<0.6?'eff_invalid_time':''"><i class="iconfont icon-valid" >有效回复:{{eff.valid_reply}}次</i></div>
    <div :class="eff.reply_count>0&&eff.valid_reply/eff.reply_count<0.6?'eff_invalid_time':''"><i class="iconfont icon-time">平均响应:{{eff.reply_time_avg}}秒</i></div>
    <div><i class="iconfont icon-deal">成单数量:共{{eff.deal}}笔</i></div>
    <div><i class="iconfont icon-amount">成单金额:共{{eff.amount}}元</i></div>
  </div>
</div>
</template>

<script>
import {mapActions } from "vuex";
import {getTodayEff} from "../../../api/app";

export default {
  name: "TheWindowHeader",
  props: {
    isStatus: Boolean,
    open: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["handleNotice"],
  data() {
    return {
      userInfo:{},
      status: false,
      isTC: false,
      notice: false,
      Connected:false,
      eff:{}
    };
  },
  watch: {
    isStatus(val) {
      this.status = val;
    },
  },
  methods: {
    handleclick() {
      this.$emit("handleNotice");
    },
    ...mapActions(["logout"]),
    handleLogout() {
      const params = {};
      if (this.userInfo.shop_id != 0) {
        params.type = 1;
      }
      this.logout().then((res) => {
        this.$net.socket.close();
        this.$router.push({
          path: "/login",
          query: params,
        });
        //关闭socket
        this.$net.socket.close();
      });
    },
    async getTodayEffect(){
      this.eff = await getTodayEff();
    },
    Disconnect(){
      this.$net.socket.close();
    },
    Reconnect(){
      this.$net.init();
    }
  },
  mounted() {
    this.$event.$on('connected',async (userInfo)=>{
        this.userInfo = userInfo;
        await this.getTodayEffect();
        this.Connected = true;
        this.$net.socket.off("message",this.getTodayEffect);
        this.$net.socket.on("message",this.getTodayEffect);
    });
    this.$event.$on('disconnected',()=>{
      this.Connected = false;
    })
  }
};
</script>

<style lang="scss" scoped>
.kefu_eff{
  width: 100%;
  height: 33px;
  background: #f7f7f7;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap:20px;
  color:#0f4eb5;
}
.eff_invalid{
  //background-color: red;
  //animation: colorChange 1.5s infinite;
}
.eff_invalid_time{
  color: #d92020;
}
.eff_invalid::after{
  content: "!!!客服绩效不达标!!!";
  color: #d92020;
}
@keyframes colorChange {
  0% {
    background-color: #f7f7f7;
  }
  50% {
    background-color: #ffe1e1;
  }
  100% {
    background-color: #f7f7f7;
  }
}
.window__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  padding: 0 20px;
  //background-color: $--color-primary;
  background-size: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-image: url("~@/assets/images/bg_header.jpg");
  color: #ffffff;
  .window-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    .imgMenu{
      margin-left: 30px;
      margin-right: 15px;
      img{
        width: 40px;
        height: 40px;
        border-radius: 5px;
      }

    }
    .textMenu{
      display: flex;
      align-items: center;
      .text1{
        //margin-right: 10px;
        font-size: 25px;
        font-weight: bold;
      }
      .imgMenu2{
        img{
          width: 30px;
          height: 30px;
        }
      }
      .text2{
        font-size: 16px;
      }

    }
  }

  .window-widget {
    display: flex;
    align-items: center;

    .widget-item {
      display: flex;
      align-items: center;
      cursor: pointer;

      &:nth-child(n + 2) {
        margin-left: 20px;
      }
    }
  }

  .on-line {
    display: block;
    content: " ";
    border-radius: 50%;
    height: 10px;
    width: 10px;
    background-color: #00c24c;
  }

  .off-line {
    display: block;
    content: " ";
    border-radius: 50%;
    height: 10px;
    width: 10px;
    background-color: #c5c5c5;
  }
}
.notice {
  margin-right: 22px;
  display: flex;
  align-items: center;
  .text{
    margin-right: 30px;
  }
  .notice-text {
    margin-right: 5px;
  }
  .image {
    width: 25px;
  }
}
.user_info {
  display: flex;
  align-items: center;
  .nickname{
    font-size: 16px;
    font-style: italic;
    font-weight: bold;
  }
  .header_photo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .dept{
    display: flex;
    gap:5px;
  }
  .dept_name{
    height: 14px;
    text-align: center;
    font-size: 11px;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
  }
  .online{
    display: block;
    height: 14px;
    width: 32px;
    font-size: 11px;
    text-align: center;
    border-radius: 2px;
    color: #fff;
    background: rgb(0,232,0);
  }
  .online.off{
    background: #ddd;
  }
}
.online-circle{
  display: inline-block;
  border: 1px solid #00E800FF;
  background: #00E800FF;
  border-radius: 50%;
  width: 12px;
  height: 12px;
}
.online-select{
  cursor: pointer;
  user-select: none;
  display: flex;
  gap:2px;
  align-items: center;
  justify-content: center;
}

.online-select.off{
  .online-circle{
    border: 1px solid red;
    background: red;
  }
}
</style>
